import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  HostListener,
  Inject,
  Renderer2,
  Optional,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT, Location } from '@angular/common';
import { PerNgPlatformService } from '@pershing/per-ng-platform-service';
import { filter, Subject, takeUntil } from 'rxjs';
import { PortalService } from './services/portal.service';
import {
  Idle,
  DocumentInterruptSource,
  StorageInterruptSource,
} from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import {
  AccountContextValue,
  ContextService,
  CoreConstants,
  DomainContext,
  AppDataStore,
  PershingHttpUtil,
  PershingTranslationService,
} from '@pershing/pershing-core';
import { AuthService } from './services/auth.service';
import { PortalNavigationService } from '@pershing/nxi-ng-common';
import { ComponentType } from '@angular/cdk/portal';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PortalConstants } from './utils/portal.constants';
import { SessionTimeoutComponent } from '@pershing/nxi-portalcomponents';
import { NavService } from './services/nav.service';
import { PageService } from './services/page.service';
import { MarketAlertsAgreementComponent } from '@pershing/nxi-ng-mod';
import { EdcWrapperComponent } from './components/edc-wrapper-component/edc-wrapper.component';
import { OrderProspectusWrapperComponent } from './components/order-prospectus-wrapper-component/order-prospectus-wrapper.component';
import moment from 'moment';
import { RedirectConfirmationPopupComponent } from '@pershing/nxi-ng-common';

const DASF_ERROR_MSG = 'DASF_errorMessage';

export const setDasfLoginScreenErrorMsg = (errorMsg): void => {
  sessionStorage.setItem(DASF_ERROR_MSG, errorMsg);
};

const LANGUAGES = [
  { key: 'en', label: 'English' },
  { key: 'es', label: 'Español' },
];
declare let citilm: any;

@Component({
  selector: 'portal-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Pershing Portal';

  // Page Control Variables
  isLoggedIn: boolean = false;
  step: string = 'login';
  isAdvisor: boolean = false;
  isDisclosures: boolean = false;
  isMobileTheme: boolean = false;
  isTabletTheme: boolean = false;
  isLazyLoadOneTrustPage: boolean = false;
  oneTrustConfig: any = {};
  isCBOL: boolean = false;
  cbolObj: any = {};
  isGeneric: boolean = false;
  dasfLoginEnabled: boolean = false;
  isDataCollectionEnabled: boolean = false;
  isModEntitled: boolean = false;
  nav: any;
  redirectUrl: string = '/nxi';
  dojoPages: string[] = []; // list of dojoPages, for ex: ["/nxi/digital-advise-mixin", etc, etc]

  //Hide and Show Variables
  showHeaderActions: boolean = true;
  logoShouldNavigateAway: boolean = true;
  hideHeaderFooter: boolean = false;
  hideHeader: boolean = false;
  hideFooter: boolean = false;
  hideMobileFooter: boolean = false;
  showLogoOnly: boolean = false;
  hideNav: boolean = false;
  hideLogoutButton: boolean = false;
  hideQuickQuote: boolean = false;
  hideOpenAccountLink: boolean = false;
  hideBreadCrumb: boolean = false;
  isSpanishEnabledIBD: boolean = false;
  hideSecondLevelNav: boolean = false; //not useable until nav refactor
  isOneClickEdelShown: boolean = false;
  showSiteTermsAndConditions: boolean = false;

  //Information Storage Variables
  isPotentialUser: boolean = false;
  languages = LANGUAGES;
  previousGoToView: string;
  routeValue: string;
  breadcrumbsval: string;
  inSeconds: number = 60;
  inmilliSeconds: number = this.inSeconds * 1000;
  ibdName: string = '';
  ibd: string = '';
  ibdURL: string = '';
  getCommunityName: string;
  inputValue: string = '';
  hashValue: string = '';
  brandedUrl: string = '';
  termsAndConditions: any;
  dfp: string = '';
  //Other Variables
  matDialogue = null;
  oneClickEnrollComponent: ComponentType<unknown>;
  unsubscribe: Subject<void> = new Subject<void>();
  lastUserAction: any;

  //Time and Keep Alive Variables
  showSessionTimer: boolean = true;
  sessionTimeOut: number;
  keepAliveTimerInterval: number;
  sessionTimeoutAlert: boolean = false;
  keepAliveId;
  keepAliveTimerActive: boolean = false;
  suppressTimeout: boolean = false;
  transactionType: string = '';
  symbol: string = '';
  accountNo: string = '';
  tradeType: string = '';
  region: any;
  isBackNavigationEnabled: boolean = false;
  navigateBySettingHref(gotoPage: string): void {
    location.href = gotoPage;
  }
  getLocationHref(): string {
    return location.href;
  }
  /**
   * If user is navigating between dojo and non-dojo page using the document:portal.gotoview
   * will do a full page refresh by setting location.href
   * @param pageToGo The page that user is navigating to
   */
  handlingNavigationBetweenDojoAndNonDojo(pageToGo: string): boolean {
    let isCurrentlyOnDojoPage: boolean = false;
    let isNavigatingToDojoPage: boolean = false;
    let currentUrl = this.getLocationHref();
    this.dojoPages.forEach((dojoPage) => {
      let regex = new RegExp(dojoPage + '([/?#;]+|$)', 'g');
      if (!isCurrentlyOnDojoPage) {
        // check every dojoPages until it's become true
        let found = currentUrl.match(regex);
        isCurrentlyOnDojoPage = !!found;
      }
      if (!isNavigatingToDojoPage) {
        let found = pageToGo.match(regex);
        isNavigatingToDojoPage = !!found;
      }
    });
    let reload = isCurrentlyOnDojoPage != isNavigatingToDojoPage;
    if (reload) {
      // do full page reload if we are navigating between non dojo and dojo
      this.navigateBySettingHref(pageToGo + '#main-container');
    }
    return reload;
  }

  @HostListener('document:portal.gotoFirstLAndingPage', ['$event'])
  handleGotoFirstLandingPage(event: any) {
    let appSettings = (window as any).pershingAppSettings;
    let url = this.getRedirectUrl(appSettings.menuConfig.postLogin[0]);
    this.redirectUrl = '/nxi';
    this.router.navigateByUrl(url);
  }

  @HostListener('document:portal.gotoview', ['$event'])
  handleGotoView(event: any) {
    // TODO:  need to resolve page to full path and enure navigation (menu) get selected as such.
    // may need to call portal.navigation.service >> handleNavigation as this is already have logic to do this.
    let context: any = event.detail.context;
    let params: any = event.detail.gotoParams;
    let page: string = event.detail.gotoPage;
    let value: any = null;
    let domain: string = null;
    let dojoAndNonDojoNavigation = false;
    if (params) {
      params = PershingHttpUtil.getQueryStringFromJsonObject(params);
      this.contextService.setRouteContext(params);
      dojoAndNonDojoNavigation = this.handlingNavigationBetweenDojoAndNonDojo(
        page + '?' + params
      );
    } else {
      // reset goto on subsequent navigation
      this.contextService.setRouteContext('');
      dojoAndNonDojoNavigation =
        this.handlingNavigationBetweenDojoAndNonDojo(page);
    }
    if (dojoAndNonDojoNavigation) {
      return; // stop the execution because the page should refresh
    }
    if (context) {
      domain = context.domain;
      value = context.value;
    }

    let result = this.setContexAndNavigate(domain, value, page);
    if (result) {
      result.then((response) => {
        if (this.previousGoToView === page) {
          let modRefreshEvent = new CustomEvent('portal.refreshmodview');
          document.dispatchEvent(modRefreshEvent);
        } else {
          this.previousGoToView = page;
        }
      });
    }
    this.hideSecondLevelNav = false;
  }

  @HostListener('document:portal.midLoginTC', ['$event'])
  midLoginTC(event: any) {
    this.contextService.setRouteContext('');
    this.navigationService.setContextAndNavigate('', '', event.detail.gotoPage);
    this.contextService.setRouteContext(event.detail.context);
  }

  setContexAndNavigate(domain: any, value: any, page: any) {
    if (
      domain === CoreConstants.ACCOUNT &&
      !(value instanceof DomainContext) &&
      this.isLoggedIn
    ) {
      let acctList = this.appDataStore.get('ACCOUNTS_LIST');
      if (!!acctList) {
        for (let i = 0; i < acctList.length; i++) {
          if (acctList[i].acctReference === value) {
            let account: any = acctList[i];
            let accountContextValue: AccountContextValue =
              new AccountContextValue(account.acctNo, value);
            accountContextValue.accountNumber =
              this.getAccountContextNumber(account);
            accountContextValue.hashValue = account.acctReference;
            accountContextValue.accountType = account.acctTypeCode;
            value = accountContextValue;
            break;
          }
        }
      }
    }
    return this.navigationService.setContextAndNavigate(domain, value, page);
  }

  getAccountContextNumber(account: any) {
    if (account.acctNo === 'ALL') {
      return 'ALL_ACCOUNTS';
    } else if (account.acctNo) {
      return account.acctNo;
    } else {
      return account.groupId;
    }
  }

  @HostListener('document:nxiDuplicateEvent', ['$event'])
  duplicateEventHandle(event: any) {
    console.log(' In sessionexist event');
    this.router.navigateByUrl('nxi/sessionexist');
  }
  @HostListener('document:nxiRedirectLoginPageEvent', ['$event'])
  redirectEventHandle(event: any) {
    console.log(' In redirect event');
    if (event.detail?.unloadTotp) {
      document.dispatchEvent(new CustomEvent('unloadTotpPage', event));
    }
    if (event.detail && event.detail.errorMessage) {
      this.contextService.setRouteContext(event.detail);
    }
    this.router.navigateByUrl('nxi/welcome?login=true');
  }
  @HostListener('document:nxiOTPEvent', ['$event'])
  otpEventHandle(event: any) {
    console.log(' In otp event');
    this.router.navigateByUrl('nxi/otp');
  }
  @HostListener('document:nxiSetUpEvent', ['$event'])
  setupEventHandle(event: any) {
    console.log(' In otp setup event');
    this.router.navigateByUrl('nxi/otpSetup');
  }

  @HostListener('document:visibilitychange')
  visibilitychange() {
    if (!document.hidden) {
      let elapsedTime = this.getMinutesBetween(this.lastUserAction, Date.now());
      if (elapsedTime < this.sessionTimeOut * this.inSeconds) {
        this.showSessionTimer = true;
      } else {
        this.showSessionTimer = false;
      }
    }
  }

  getMinutesBetween(lastUserAction: any, currentTime: any) {
    const elapsedTime = currentTime - lastUserAction;
    return elapsedTime / 1000;
  }

  @HostListener('document:nxiLogonEvent', ['$event'])
  saEventHandle(event: any) {
    console.log(' In sa event' + event.detail);
    if (event.detail.dasfDetails && event.detail.page) {
      // Update the acl details from dasf response in appsettings
      this.brandedUrl = '';
      let userId = event.detail.dasfDetails.userid;
      let ibd = event.detail.dasfDetails.corrnum;
      if (event.detail.dasfDetails.dfp && this.dfp === '') {
        this.dfp = event.detail.dasfDetails.dfp;
      }
      if (
        this.showSiteTermsAndConditions &&
        event.detail.page !== 'midlogindasf'
      ) {
        this.authService.showSiteTermsAndConditions(userId, ibd).subscribe(
          (response) => {
            this.termsAndConditions = response;
            if (this.termsAndConditions) {
              this.contextService.setRouteContext('');
              this.navigationService.setContextAndNavigate(
                '',
                '',
                '/nxi/midlogintc'
              );
              this.contextService.setRouteContext(event.detail);
              return;
            }
          },
          (error) => {
            console.log(error);
          }
        );
      }

      this.handleDasfResponse(event, userId, ibd);
    } else {
      this.router.navigateByUrl('nxi/welcome');
    }
  }

  handleDasfResponse(event: any, userId: any, ibd: any) {
    if (
      event.detail.dasfDetails.Response &&
      event.detail.page === 'midlogindasf' &&
      !window.location.search.includes('token')
    ) {
      let userSourceCode: string = '';
      let dbReturnCode: string = '';
      if (event.detail.nxiDetails && event.detail.nxiDetails.userSourceCode) {
        userSourceCode = event.detail.nxiDetails.userSourceCode;
      }
      if (event.detail.nxiDetails && event.detail.nxiDetails.DBReturnCode) {
        dbReturnCode = event.detail.nxiDetails.DBReturnCode;
      }

      this.authService
        .getBrandedRedirect(userId, ibd, userSourceCode, this.dfp, dbReturnCode)
        .subscribe((response) => {
          this.handleBrandRedirectResponse(response, event);
        });
    } else {
      this.contextService.setRouteContext('');
      this.navigationService.setContextAndNavigate(
        '',
        '',
        '/nxi/' + event.detail.page
      );
      this.contextService.setRouteContext(event.detail);
    }
  }
  getRedirectUrl(parent: any) {
    if (parent.children?.length > 0) {
      this.redirectUrl = this.redirectUrl + '/' + parent.id;
      return this.getRedirectUrl(parent.children[0]);
    }
    return this.redirectUrl + '/' + parent.id;
  }
  handleBrandRedirectResponse(response: any, event: any) {
    if (response.siteAccessErrorMsg && response.siteAccessErrorMsg !== '') {
      setDasfLoginScreenErrorMsg(response.siteAccessErrorMsg);
      // location.href = '/nxi/welcome?login=true';
      this.updateLocationHref('/nxi/welcome?login=true&errorCode=CAI802');
      return;
    }
    if (
      response.potentialUserErrorMsg &&
      response.potentialUserErrorMsg !== ''
    ) {
      setDasfLoginScreenErrorMsg(response.potentialUserErrorMsg);
      let reloadParam = { reload: new Date().getTime() };
      // location.href = '/nxi/welcome?login=true';
      this.updateLocationHref('/nxi/welcome?login=true&errorCode=CAI002');
      return;
    }
    this.brandedUrl = response.brandedUrl;
    console.log('Branded URL is ' + this.brandedUrl);
    if (response.brandedUrl && !this.brandedUrl.includes(this.ibdURL)) {
      let url = this.brandedUrl.split('?')[0];
      console.log('URL got is ' + url);
      url = url.replace('login', event.detail.page);
      //console.log('URL to post is ' + url);
      let form = document.createElement('form');
      form.action = url;
      form.method = 'POST';
      let input = document.createElement('input');
      input.name = 'dasfstorage';
      let appSettings = (window as any).pershingAppSettings;
      if (appSettings.companyName) {
        event.detail.companyName = appSettings.companyName;
        event.detail.custServicePhoneNum = appSettings.custServicePhoneNum;
        event.detail.techSupportPhoneNum = appSettings.techSupportPhoneNum;
        event.detail.custServiceEmailAddress =
          appSettings.custServiceEmailAddress;
      }
      if (appSettings.brandInd) {
        event.detail.brandInd = appSettings.brandInd;
      }
      input.value = escape(JSON.stringify(event.detail));
      input.type = 'hidden';
      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
    } else {
      this.contextService.setRouteContext('');
      this.navigationService.setContextAndNavigate(
        '',
        '',
        '/nxi/' + event.detail.page
      );
      this.contextService.setRouteContext(event.detail);
    }
  }

  updateLocationHref(url: string) {
    location.href = url;
  }

  replaceLocation(details: any) {
    location.replace(details);
  }
  @HostListener('document:nxiSetUpQAEvent', ['$event'])
  sasetupEventHandle(event: any) {
    console.log(' In otp event');
    this.router.navigateByUrl('nxi/saSetup');
  }
  @HostListener('document:nxiChangePasswordEvent', ['$event'])
  changePwdEventHandle(event: any) {
    console.log(' In otp event');
    this.router.navigateByUrl('nxi/changepwd');
  }
  @HostListener('document:nxiUpdateSecEvent', ['$event'])
  securityEmailEventHandle(event: any) {
    console.log(' In otp event');
    this.router.navigateByUrl('nxi/securityEmail');
  }
  @HostListener('document:nxiLoginEvent', ['$event'])
  loginEventHandle(event: any) {
    console.log(' In login event  DASF Details' + event.detail.dasfDetails);
    if (event.detail.dasfDetails) {
      let userId = event.detail.dasfDetails.userid;
      if (!this.ibd && event.detail.dasfDetails.corrnum) {
        this.ibd = event.detail.dasfDetails.corrnum;
      }
      let lastLogin = '';
      if (event.detail.dasfDetails.lastSignonDate) {
        console.log(
          'Last login date' + event.detail.dasfDetails.lastSignonDate
        );
        lastLogin = event.detail.dasfDetails.lastSignonDate;
      }
      this.contextService.setRouteContext('');
      if (event.detail.dasfDetails.otpOnlineRegFlow) {
        this.dfp = event.detail.dasfDetails.dfp;
      }
      sessionStorage.setItem(
        'dasfDetails',
        JSON.stringify(event.detail.dasfDetails)
      );
      this.authService
        .redirectToNxiLandingPage(userId, this.ibd, lastLogin, this.dfp)
        .subscribe(
          (response) => {
            this.handleLandingPageResponse(response, event);
          },
          (error) => {
            console.log(error);
            if (event.detail) {
              // location.replace(event.detail);
              this.replaceLocation(event.details);
            }
            document.dispatchEvent(
              new CustomEvent('portal.gotoview', {
                detail: {
                  gotoPage: '/nxi/welcome',
                },
              })
            );
          }
        );
    } else {
      document.dispatchEvent(
        new CustomEvent('portal.gotoview', {
          detail: {
            gotoPage: '/nxi/welcome',
          },
        })
      );
    }
  }
  @HostListener('document:DASF_UserActivityEvent', ['$event'])
  DASFUserActivityEvent(event: any) {
    console.log('event details',event);
    const activity = event.detail.Activity;
    const status = event.detail.status;
    console.log(`Activity: ${activity}, Status: ${status}`);
    if(status === 'Failure') {
      if (window['adobeDataLayer']) {
        let taggedValue = {
          event: 'callToAction',
          attributes: {
            page: {
              friendlyName: activity,
              pageTitle: document.querySelector('title').innerText,
              canonicalURL:
                window.location.protocol + '//' + window.location.host,
              fullURL: document.location.href,
            },
            element: {
              componentName: 'landingPage',
            },
            appPath: { loginResult: 'Attempted login' },
            timestamp: moment(new Date()).format('HH:mm:ss.SSS'),
            environment: this.region,
            siteVersion: 'NETXinvestor',
          },
        };
        window['adobeDataLayer'].push(taggedValue);
      }
    }
  }

  handleLandingPageResponse(response: any, event: any) {
    if (window['adobeDataLayer']) {
      let taggedValue = {
        event: 'callToAction',
        attributes: {
          page: {
            friendlyName: 'landingPage',
            pageTitle: document.querySelector('title').innerText,
            canonicalURL:
              window.location.protocol + '//' + window.location.host,
            fullURL: document.location.href,
          },
          element: {
            componentName: 'landingPage',
          },
          appPath: { loginResult: 'successful login' },
          timestamp: moment(new Date()).format('HH:mm:ss.SSS'),
          environment: this.region,
          siteVersion: 'NETXinvestor',
        },
      };
      window['adobeDataLayer'].push(taggedValue);
    }
    let url = '/nxi/redirectLandingPage?landingPage=default';
    if (response) {
      let landingPage = response.landingPage ? response.landingPage : 'default';
      url = '/nxi/redirectLandingPage?landingPage=' + landingPage;
      console.log('landing page -- ', landingPage);
      if (response.communityName) {
        url = url + '&communityName=' + response.communityName;
      }
      if (response.themeType) {
        url = url + '&userThemeType=' + response.themeType;
      }
      if (response.isModern) {
        url = url + '&isModern=' + response.isModern;
      }
    }
    this.platformService.setUserId(event.detail.dasfDetails.userid);
    if (event.detail) {
      this.contextService.setRouteContext(event.detail);
      // location.href = url;
      this.updateLocationHref(url);
    } else {
      // location.href = url;
      this.updateLocationHref(url);
    }
  }

  @HostListener('document:timeoutEvent', ['$event'])
  timeoutEventHandle(event: any) {
    if (event.detail.status === 'continue') {
      this.authService.invokeKeepAlive().subscribe();
      this.matDialogue = null;
      //this.lastUserAction = new Date();
      this.invokeIdleWatch();
    } else {
      this.authService.logout('timedOut');
    }
  }

  @HostListener('document:nxiAclEvent', ['$event'])
  aclupdate(event: any) {
    if (event.detail.acl) {
      this.captureAndSetACLDetails(event.detail);
    }
  }

  @HostListener('document:portal.LogoutEvent')
  logout() {
    if (this.dasfLoginEnabled) {
      console.log('Calling DASF logout method');
      this.authService.invokeDasfLogout();
    } else {
      console.log('Calling NXI logout method');
      this.authService.logout();
    }
  }

  @HostListener('document:portal.DASFLogoutEvent')
  invokeDasflogout() {
    this.authService.invokeDasfLogout();
  }

  @HostListener('document:portal.footerNavigation', ['$event'])
  footerNavigation(event: any) {
    if (event?.detail?.gotoPage) {
      this.router.navigateByUrl(event.detail.gotoPage);
    }
  }

  constructor(
    private platformService: PerNgPlatformService,
    private portalService: PortalService,
    private translationService: PershingTranslationService,
    private router: Router,
    private appDataStore: AppDataStore,
    private cd: ChangeDetectorRef,
    private idle: Idle,
    private matDialog: MatDialog,
    private keepalive: Keepalive,
    private contextService: ContextService,
    private authService: AuthService,
    private navigationService: PortalNavigationService,
    private menuService: NavService,
    private pageService: PageService,
    @Optional() @Inject('AppSettings') appSettings: any,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private location: Location
  ) {
    // let basePath = PathManipulation.getBasePath(appSettings);
    // if (basePath != null) {
    //   this.translationService.addTranslationFolder('@pershing/nxi-ng-common', basePath + '/lib');
    // } else {
    //   this.translationService.addTranslationFolder('@pershing/nxi-ng-common', '/lib');
    // }
    this.suppressTimeout = appSettings.isSitebuilder && appSettings.previewSite;
    let parsemap = appSettings.ibdConfigMap;
    //if user comes thru SSO route and if time out is not configured in ssoConfig, we have set default value of sessionTimeoutOfSSO to 20
    if (appSettings.isVendorSso && appSettings.sessionTimeoutOfSSO) {
      this.sessionTimeOut = appSettings.sessionTimeoutOfSSO;
    } else {
      this.sessionTimeOut = parsemap.sessionTimeOut;
    }
    this.keepAliveTimerInterval = parsemap.keepAliveTimerInterval
      ? parsemap.keepAliveTimerInterval
      : 10;
    this.isLoggedIn = appSettings.isLoggedIn;
    this.isAdvisor = appSettings.isAdvisor;
    this.isPotentialUser = appSettings?.isPotentialUser || false;
    this.ibd = parsemap.IBD;
    if (appSettings.transactionType) {
      this.transactionType = appSettings.transactionType;
      delete appSettings.transactionType;
    }
    if (appSettings.symbol) {
      this.symbol = appSettings.symbol;
      delete appSettings.symbol;
    }
    if (appSettings.tradeType) {
      this.tradeType = appSettings.tradeType;
      delete appSettings.tradeType;
    }
    if (
      appSettings.ssoDefaultLandingAccount &&
      this.symbol &&
      this.transactionType &&
      this.tradeType
    ) {
      this.accountNo = appSettings.ssoDefaultLandingAccount;
    }
    this.oneClickEnrollComponent = EdcWrapperComponent;

    this.ibdName =
      !!appSettings.ibdConfigMap && !!appSettings.ibdConfigMap.ibdName
        ? appSettings.ibdConfigMap.ibdName
        : '';
    this.region = appSettings.region;

    this.setUpAppSettingsConditions(appSettings);

    if (parsemap.isDataCollectionEnabled) {
      this.isDataCollectionEnabled = parsemap.isDataCollectionEnabled;
    }
    if (parsemap.showSiteTermsAndConditions) {
      this.showSiteTermsAndConditions = parsemap.showSiteTermsAndConditions;
    }

    let spanishSiteEnabledIBDs = parsemap.spanishSiteEnabledIBD;
    if (
      spanishSiteEnabledIBDs.includes(appSettings.ibdConfigMap.IBD) ||
      (appSettings.ibdConfigMap.generic &&
        appSettings.ibdConfigMap.community === 'netxinvestor')
    ) {
      this.isSpanishEnabledIBD = true;
    }

    this.isGeneric = parsemap.generic;
    this.getCommunityName = parsemap.community;
    this.isCBOL = appSettings.isCBOL;

    this.ibdURL = parsemap.URL;

    this.cbolObj = appSettings.cbolObj || {};
    if (appSettings.dojoPages) {
      this.dojoPages = appSettings.dojoPages;
    }
  }

  setUpAppSettingsConditions(appSettings: any) {
    if (appSettings.dasfLoginEnabled) {
      this.dasfLoginEnabled = appSettings.dasfLoginEnabled;
    }

    if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
      this.isMobileTheme = true;
    } else if (appSettings.deviceType && appSettings.deviceType === 'tablet') {
      this.isTabletTheme = true;
    }

    if (appSettings.hideHeaderFooter) {
      this.hideHeaderFooter = appSettings.hideHeaderFooter;
      if (appSettings.ibdConfigMap.backNavigationConfig && appSettings.ibdConfigMap.backNavigationConfig.enabled) {
        this.isBackNavigationEnabled = true;
      }
    }

    if (appSettings.isLazyLoadOneTrustPage) {
      this.isLazyLoadOneTrustPage = true;
      this.oneTrustConfig = appSettings.onetrustConfig;
    }

  }

  switchLanguage(language: string) {
    this.translationService.use(language);
  }

  captureAndSetACLDetails(dasfResponse: any) {
    let parserResponse = dasfResponse;
    let appSettings = (window as any).pershingAppSettings;
    if (
      parserResponse &&
      parserResponse.acl &&
      parserResponse.acl[0] &&
      parserResponse.acl[0].aclIbd
    ) {
      appSettings.companyName = parserResponse.acl[0].aclIbd.companyName;
      appSettings.custServicePhoneNum =
        parserResponse.acl[0].aclIbd.custServicePhoneNum;
      appSettings.techSupportPhoneNum =
        parserResponse.acl[0].aclIbd.techSupportPhoneNum;
      appSettings.custServiceEmailAddress =
        parserResponse.acl[0].aclIbd.custServiceEmailAddress;
      if (
        parserResponse.acl[0].aclSitesList &&
        parserResponse.acl[0].aclSitesList[0]
      ) {
        appSettings.brandInd = parserResponse.acl[0].aclSitesList[0].brandInd;
      }
    }
  }

  SetACLDetailsforafterreload(data: any) {
    if (data) {
      let appSettings = (window as any).pershingAppSettings;
      if (data.companyName) {
        appSettings.companyName = data.companyName;
        appSettings.custServicePhoneNum = data.custServicePhoneNum;
        appSettings.techSupportPhoneNum = data.techSupportPhoneNum;
        appSettings.custServiceEmailAddress = data.custServiceEmailAddress;
      }
      if (data.brandInd) {
        appSettings.brandInd = data.brandInd;
      }
    }
  }

  invokeIdleWatch() {
    this.idle.watch();
  }

  createDefaultInterruptSources(options?) {
    return [
      new DocumentInterruptSource(
        'keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll',
        options
      ),
      new StorageInterruptSource(),
    ];
  }

  getAccountRef(accountNo: String) {
    let acctList = this.appDataStore.get('ACCOUNTS_LIST');
    if (!!acctList) {
      for (let i = 0; i < acctList.length; i++) {
        if (acctList[i].acctNo === accountNo) {
          return acctList[i];
        }
      }
    }
    return null;
  }
  // uncomment if required
  // clearKeepAliveTimer() {
  //     if (this.keepAliveTimerActive && this.keepAliveId) {
  //         clearInterval(this.keepAliveId);
  //         this.keepAliveTimerActive = false;
  //     }
  // }

  sessionTimeOutWarning(prelogin = false) {
    if (!this.sessionTimeoutAlert && !this.suppressTimeout) {
      this.idle.setIdle(this.sessionTimeOut * this.inSeconds);
      this.sessionTimeoutAlert = true;
      this.idle.setInterrupts(this.createDefaultInterruptSources());
      this.idle.onIdleStart.subscribe(() => {
        if (!prelogin && this.showSessionTimer && !document.hidden) {
          if (!this.matDialogue) {
            this.matDialogue = this.matDialog.open(SessionTimeoutComponent, {
              width: '507px',
              panelClass: ['modal'],
            });
          }
        } else {
          this.authService.logout('timedOut');
        }
      });
      if (!prelogin && !this.keepAliveTimerActive) {
        this.keepAliveTimerActive = true;
        this.keepAliveId = setInterval(() => {
          this.authService.invokeKeepAlive().subscribe();
        }, this.keepAliveTimerInterval * this.inmilliSeconds);
      }
      this.invokeIdleWatch();
    }
  }

  ngAfterViewInit() {
    if (
      this.isCBOL &&
      this.cbolObj &&
      !this.cbolObj.enableCbolRestBranding &&
      citilm
    ) {
      citilm.loadCitiBrand();
      citilm.loadCitiFooter();
    }
  }

  ngOnInit(): void {
    // initialize portal service
    //this._portalService.init();
    // initialize handlers
    this.menuService.menuItems$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((menus) => {
        if (menus) {
          this.nav = menus;
        }
      });

    this.menuService.menuItems$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((menus) => {
        if (menus) {
          this.nav = menus;
        }
      });

    this.isDisclosures = this.location.path().indexOf('/nxi/disclosure') === 0;

    document.dispatchEvent(new CustomEvent('portal.breadcrumbs'));
    console.log(' In Portal OnInit ');
    let removeLoadingAnimation = new CustomEvent(
      'portal.removeLoadingAnimation'
    );
    document.dispatchEvent(removeLoadingAnimation);

    this.handleRouterEvents();

    if (sessionStorage.getItem('DASFResponse')) {
      this.contextService.setRouteContext(
        JSON.parse(unescape(sessionStorage.getItem('DASFResponse')))
      );
      this.SetACLDetailsforafterreload(
        JSON.parse(unescape(sessionStorage.getItem('DASFResponse')))
      );
      sessionStorage.removeItem('DASFResponse');
    }
    if (sessionStorage.getItem('DASFDfp')) {
      this.dfp = JSON.parse(sessionStorage.getItem('DASFDfp'));
      sessionStorage.removeItem('DASFDfp');
    }
    if (this.isCBOL && this.cbolObj && this.cbolObj.enableCbolRestBranding) {
      this.authService.fetchCbolBranding(this.cbolObj).subscribe((response) => {
        const cbolrespscript = this.renderer2.createElement('script');
        this.renderer2.setProperty(cbolrespscript, 'text', `${response}`);
        this.renderer2.appendChild(this._document.body, cbolrespscript);
        setTimeout(() => {
          citilm.loadCitiBrand();
          citilm.loadCitiFooter();
        }, 2000);
      });
    }
    this.hideFooterBasedOnCommunity();
  }

  handleRouterEvents() {
    this.router.events
      .pipe(
        takeUntil(this.unsubscribe),
        filter((event) => event instanceof NavigationEnd),
        filter(
          (event) => !(event as NavigationEnd).url.includes('dummy/refresh')
        )
      ) // ignore dummy/refresh
      .subscribe((event: NavigationEnd) => {
        console.log(' In PortalApp router event ');
        let requestUrl = event.url;
        const tree = this.router.parseUrl(requestUrl);
        if (tree.fragment) {
          const element = document.querySelector('#' + tree.fragment);
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'nearest',
            });
          }
        }

        console.log('request url after router event - ', requestUrl);

        //this.handleTradingRoute();

        this.dataCollectionEnabledEvents(requestUrl);

        this.routerUrlChecks(requestUrl);

        let hideNavigation = false;
        let hideHeaderComp = false;
        this.hideLogoutButton = false;
        this.hideQuickQuote = false;
        let hideFooterComp = false;
        this.hideBreadCrumb = false;
        this.hideOpenAccountLink = false;
        console.log('request url before hide nav list - ' + requestUrl);
        PortalConstants.HideNavList.forEach((element) => {
          if (requestUrl.includes(element.pageName, 2)) {
            hideNavigation = element.hideNavigation;
            hideHeaderComp = element.hideHeader;
            hideFooterComp = element.hideFooter;
            this.showLogoOnly = element.showLogoOnly;
            this.hideLogoutButton = element.hideLogoutButton;
            this.hideQuickQuote = element.hideQuickQuote;
            if (!!element.hideBreadCrumb) {
              this.hideBreadCrumb = element.hideBreadCrumb;
            }
            if (!!element.hideOpenAccountLink) {
              this.hideOpenAccountLink = element.hideOpenAccountLink;
            }
          }
        });
        // hide menu for potential user
        if (
          requestUrl.includes('savedaccountapplications') &&
          this.isPotentialUser
        ) {
          hideNavigation = true;
          this.showLogoOnly = true;
          this.hideLogoutButton = true;
          this.hideQuickQuote = true;
          this.showHeaderActions = false;
          this.logoShouldNavigateAway = false; // prevent the logo take the user to other page
        }
        this.hideNav = hideNavigation;
        this.hideHeader = hideHeaderComp;
        this.hideFooter = hideFooterComp;
      });
  }

  handleTradingRoute() {
    if (
      this.accountNo &&
      this.transactionType &&
      this.symbol &&
      this.tradeType
    ) {
      let trade = '';
      let accountRef = this.getAccountRef(this.accountNo);
      console.log('account ref', accountRef);
      console.log('INSIDE trade SSO block');
      console.log(
        'values passed',
        this.transactionType,
        this.symbol,
        this.tradeType
      );
      if (this.tradeType == 'ETF') {
        trade = 'EQUITY';
      } else {
        trade = this.tradeType;
      }
      let value = {
        transactionType: this.transactionType,
        tradeType: trade,
        symbol: this.symbol,
        account: accountRef.acctReference,
      };
      const accountContextValue: AccountContextValue = new AccountContextValue(
        this.accountNo
      );
      accountContextValue.hashValue = accountRef.acctReference;
      accountContextValue.accountType = accountRef.acctTypeCode;
      this.contextService.setDomainContext(
        CoreConstants.ACCOUNT,
        accountContextValue
      );
      this.contextService.setRouteContext(value);
      this.transactionType = '';
      this.symbol = '';
      this.accountNo = '';
      this.tradeType = '';
    }
  }
  dataCollectionEnabledEvents(requestUrl: string) {
    if (this.isDataCollectionEnabled) {
      if (
        requestUrl.includes('midlogin') ||
        requestUrl.includes('nxi/otp') ||
        requestUrl.includes('nxi/sa')
      ) {
        this.emitPageDetails('security_question');
      } else if (
        requestUrl.includes('fundstransfer') ||
        requestUrl.includes('neworder')
      ) {
        this.emitPageDetails('transaction');
      } else if (
        requestUrl.includes('settings') ||
        requestUrl.includes('changepassword') ||
        requestUrl.includes('postlogin-security') ||
        requestUrl.includes('resetpassword') ||
        requestUrl.includes('changepwd') ||
        requestUrl.includes('updateSec') ||
        requestUrl.includes('securityEmail')
      ) {
        this.emitPageDetails('change_details');
      } else if (requestUrl.includes('payee')) {
        this.emitPageDetails('add_payee');
      } else if (
        !requestUrl.includes('welcome') &&
        !requestUrl.includes('login') &&
        !requestUrl.includes('overview')
      ) {
        this.emitPageDetails('other');
      }
    }
  }

  routerUrlChecks(requestUrl: string) {
    let urlArray = requestUrl.split('/');
    if (urlArray[urlArray.length - 1].split('?').length > 1) {
      urlArray[urlArray.length - 1] =
        urlArray[urlArray.length - 1].split('?')[0];
    }
    if (urlArray[urlArray.length - 1].split('#').length > 1) {
      urlArray[urlArray.length - 1] =
        urlArray[urlArray.length - 1].split('#')[0];
    }
    if (urlArray[urlArray.length - 1].split(';').length > 1) {
      urlArray[urlArray.length - 1] =
        urlArray[urlArray.length - 1].split(';')[0];
    }
    let lastIndex = urlArray[urlArray.length - 1];
    if (
      lastIndex === 'nxi' ||
      lastIndex === 'login' ||
      lastIndex === 'welcome'
    ) {
      this.routeValue = 'login';
      if (localStorage.getItem('awrDataContext')) {
        localStorage.removeItem('awrDataContext');
      }
    } else {
      this.routeValue = lastIndex;
    }
    document.getElementsByTagName('title')[0].innerText =
      this.ibdName +
      ' - ' +
      this.translationService.translate.instant(this.routeValue);
    if (urlArray[2] === 'disclosure') {
      this.step = 'disclosure';
      this.isDisclosures = true;
    } else if (
      PortalConstants.PreloginPagesList.indexOf(lastIndex) !== -1 ||
      lastIndex === ' ' ||
      lastIndex.includes('welcome;reload=')
    ) {
      this.preLoginPagesLogic(lastIndex);
    } else {
      this.postLoginPagesLogic();
    }
  }

  preLoginPagesLogic(lastIndex: string) {
    this.step = 'login';
    this.isLoggedIn = false;
    this.showLogoOnly = true;
    // (window as any).appSettings.isLoggedIn = false;
    if (PortalConstants.PreLoginSessionTimeoutPages.indexOf(lastIndex) !== -1) {
      console.log('Session timeout invoked for prelogin view ', lastIndex);
      this.sessionTimeOutWarning(true);
      if (lastIndex === 'duplicatesessionconfirmation') {
        this.showLogoOnly = true;
        this.hideLogoutButton = true;
      }
    }
    if (
      lastIndex.includes('account-types-nao') ||
      lastIndex.includes('account-creation-info-nao') ||
      lastIndex.includes('account-verid-nao-ng') ||
      lastIndex.includes('account-verid-nao') ||
      lastIndex.includes('account-verid-qa-nao') ||
      lastIndex.includes('account-new-userid-nao') ||
      lastIndex.includes('digital-advise-splash') ||
      lastIndex.includes('digital-advise-mixin')
    ) {
      console.log('accopeng pages' + this.sessionTimeoutAlert);
      if (!this.sessionTimeoutAlert) {
        console.log('sessiontimeout' + this.sessionTimeOut);
        this.idle.setIdle(this.sessionTimeOut * this.inSeconds);
        this.sessionTimeoutAlert = true;
        this.idle.setInterrupts(this.createDefaultInterruptSources());
        console.log('before redirection 1');
        this.idle.onIdleStart.subscribe(() => {
          console.log('before redirection 2');
          this.authService.logout('timedOut');
        });
        this.invokeIdleWatch();
      }
    }
  }

  postLoginPagesLogic() {
    this.step = 'postLogin';
    this.isLoggedIn = true;
    // (window as any).appSettings.isLoggedIn = true;
    if (this.isLoggedIn) {
      this.sessionTimeOutWarning();
    }
    if (!this.isOneClickEdelShown) {
      this.authService.isOneClickEdelEnabled().subscribe(
        (response) => {
          this.isOneClickEdelShown = true;
          if (response && response.showOneClickEdel) {
            let isshowInterstitial = false;
            if (response.forceEnrollFlag === 'Y') {
              isshowInterstitial = true;
            }
            if (this.matDialog.openDialogs.length === 0) {
              this.matDialog.open(this.oneClickEnrollComponent, {
                panelClass: ['modal', 'edel-OneClick'],
                disableClose: true,
                data: {
                  showInterstitial: isshowInterstitial,
                  goPaperless: response.showOneClickFromGopaperless,
                  suppressOneClickEnrollCancel:
                    response.suppressOneClickEnrollCancel,
                },
              });
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  hideFooterBasedOnCommunity() {
    if (!this.isMobileTheme && !this.isTabletTheme) {
      if (this.getCommunityName == 'wealthgen' && this.isLoggedIn) {
        this.hideHeaderFooter = false;
      } else if (this.getCommunityName == 'wealthgen' && !this.isLoggedIn) {
        this.hideHeaderFooter = true;
      }
    } else {
      if (this.getCommunityName == 'wealthgen' && this.isLoggedIn) {
        this.hideMobileFooter = false;
      } else if (this.getCommunityName == 'wealthgen' && !this.isLoggedIn) {
        this.hideMobileFooter = true;
      }
    }
  }

  emitPageDetails(action) {
    let emitFrameDetails = new CustomEvent('portal.emitFrameDetails', {
      detail: action,
    });
    document.dispatchEvent(emitFrameDetails);
  }

  cookieNotice() {
    let pagePath = '/nxi/privacy-policy/cookie-notice-policy';
    let url =
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '') +
      pagePath;
    let PcEl = document.getElementsByClassName('menu-item-moreinfo')[0];
    if (
      PcEl !== null &&
      PcEl !== undefined &&
      PcEl.firstChild !== null &&
      PcEl.firstChild !== undefined
    ) {
      let PcTarget = PcEl.firstChild.firstChild;
      if (PcTarget !== null && PcTarget !== undefined) {
        // PcTarget.setAttribute('href', url);
        // PcTarget.setAttribute('target', '_self');
      }
    }
    let BanTarget = document.getElementsByClassName('banner-policy-link')[0];
    BanTarget.setAttribute('href', url);
    BanTarget.setAttribute('target', '_self');
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    console.log('In PortalApp Destroy ');
  }
  @HostListener('window:market/alertsAgreement', ['$event'])
  callAlertAgreementEvent(event: any) {
    if (!!event.detail.data && !!event.detail.agreementToPage) {
      this.matDialog.open(MarketAlertsAgreementComponent, {
        panelClass: ['alrt-MarketAlerts_Dialog'],
        data: {
          data: event.data,
          status: event.agreementToPage,
          isAdvisor: this.isAdvisor,
        },
      });
    }
  }
  @HostListener('document:portal.browserTitleValue', ['$event'])
  UpdateBrowserTitle(event: any) {
    document.getElementsByTagName('title')[0].innerText =
      this.ibdName +
      ' - ' +
      this.translationService.translate.instant(event.detail.titleValue);
    const classes: string = document.body.getAttribute('class');
    if (classes && classes.length > 0) {
      const classList: string[] = classes.split(' ');
      const updatedClassList = classList.filter(
        (c: string) => !c.startsWith('page-')
      );
      updatedClassList.push(
        'page-' + event.detail.titleValue.split(/[. ]+/).pop().toLowerCase()
      );
      document.body.setAttribute('class', updatedClassList.join(' '));
    } else {
      document.body.setAttribute(
        'class',
        'page-' + event.detail.titleValue.split(/[. ]+/).pop().toLowerCase()
      );
    }
    this.hideSecondLevelNav = false;
  }
  @HostListener('document:portal.hidesecondlevelnav', ['$event'])
  hidesecondlevelnavEvent(event: any) {
    if (!!event.detail.hideSecondlevelNav) {
      this.hideSecondLevelNav = event.detail.hideSecondlevelNav;
    } else {
      this.hideSecondLevelNav = false;
    }
  }
  /*for iPhone and iPad not support "beforeunload" so need to use "pagehide" */
  @HostListener('window:pagehide')
  /* OnBeforeUnload event(page refresh/open in new tab) populates the selected domain context in browser LocalStorage. */
  @HostListener('window:beforeunload')
  OnBeforeUnload() {
    if (this.contextService.getRouteContext()) {
      let contextdetails: any = this.contextService.getRouteContext();
      if (typeof contextdetails === 'object') {
        let appSettings = (window as any).appSettings;
        if (appSettings.companyName) {
          contextdetails.companyName = appSettings.companyName;
          contextdetails.custServicePhoneNum = appSettings.custServicePhoneNum;
          contextdetails.techSupportPhoneNum = appSettings.techSupportPhoneNum;
          contextdetails.custServiceEmailAddress =
            appSettings.custServiceEmailAddress;
        }
        if (appSettings.brandInd) {
          contextdetails.brandInd = appSettings.brandInd;
        }
        sessionStorage.setItem('DASFResponse', JSON.stringify(contextdetails));
        sessionStorage.setItem('DASFDfp', JSON.stringify(this.dfp));
      }
      if (this.authService.isValid()) {
        this.contextService.saveLocalStorage();
      }
    }
  }
  @HostListener('document:pershing.content.management.placeontrust')
  plcaeOntrust() {
    if (this.isLazyLoadOneTrustPage && this.oneTrustConfig) {
      const ele = document.createElement('script');
      ele.setAttribute('type', 'text/javascript');
      ele.setAttribute('src', this.oneTrustConfig.oneTrustScriptAutoblock);
      document.head.appendChild(ele);
      const stubele = document.createElement('script');
      stubele.setAttribute('type', 'text/javascript');
      stubele.setAttribute('src', this.oneTrustConfig.oneTrustScriptSdkStub);
      stubele.setAttribute(
        'data-domain-script',
        this.oneTrustConfig.oneTrustDataDomainAttribute
      );
      document.head.appendChild(stubele);
    }
  }

  @HostListener('document:portal.oneClickEvent', ['$event'])
  invokeOneClickEvent(event: any) {
    let isshowInterstitial = false;
    if (event.detail.forceEnrollFlag === 'Y') {
      isshowInterstitial = true;
    }
    if (this.matDialog.openDialogs.length === 0) {
      this.matDialog.open(this.oneClickEnrollComponent, {
        panelClass: ['modal', 'edel-OneClick'],
        disableClose: true,
        data: {
          showInterstitial: isshowInterstitial,
          goPaperless: event.detail.goPaperless,
          suppressOneClickEnrollCancel:
            event.detail.suppressOneClickEnrollCancel,
        },
      });
    }
  }

  @HostListener('window:openOrderProspectusForm', ['$event'])
  openOrderProspectusEvent(event: any) {
    let quote = {
      cusipId: event.detail.symbol,
      symId: event.detail.cusipId,
    } as any;
    let isWindowBigSize = window.innerWidth > 1280;
    let dialogWidth = '80%';

    if (isWindowBigSize) {
      dialogWidth = '60%';
    }

    this.matDialog.open(OrderProspectusWrapperComponent, {
      panelClass: 'modal',
      autoFocus: false,
      disableClose: true,
      data: {
        quote: quote,
      },
    });
  }

  @HostListener('document:redirectConfirmation', ['$event'])
  redirectConfirmationEvent(event: any) {
    let url = event.detail.redirectUrl;
    this.matDialog.open(RedirectConfirmationPopupComponent, {
      disableClose: true,
      panelClass: ['', 'modal'],
      maxWidth: '81vw',
      data: {
          redirectUrl: url,
      },
    })
  }
}
